import { render, staticRenderFns } from "./ProductLinkSoftbook.vue?vue&type=template&id=320b6e02&"
import script from "./ProductLinkSoftbook.ts?vue&type=script&lang=ts&"
export * from "./ProductLinkSoftbook.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ProductLinkSoftbook.vue"
export default component.exports